import {SplitButton} from "primereact/splitbutton";
import {Button} from "primereact/button";
import {Image} from "primereact/image";
import React, {useContext, useEffect, useState} from "react";
import {InputText} from "primereact/inputtext";
import {SongService} from "../services/SongService";
import {AuthContext} from "../App";
import {MainPageContext} from "./MainPage";
import {Dialog} from "primereact/dialog";
import {AMService} from "../services/AMService";

export function PlaylistSaveToStreamingService({playlist, onSaved, spotifyUsers,
                                                   setEditInfo, buttonsDisabled, setButtonsDisabled,
                                                   editInfo ={editable: false, spotifyplaylist_id: "undefined", spotifyuser_id: -1, plname:"", pldescription:""}}) {

    const [showAMconnectDialog, setShowAMConnectDialog] = useState(false);
    const [showEditDialog, setShowEditDialog] = useState(false);
    const songservice = new SongService();
    const amservice = new AMService();
    const auth = useContext(AuthContext);
    const mp = useContext(MainPageContext);

    useEffect(() => {
        if(playlist.length === 0){
            setButtonsDisabled(true);
        } else {
            setButtonsDisabled(false);
        }
    }, [playlist, editInfo]);


    const savePlaylistToSpotify = (spotifyuser_id, edit = false) => {
        if(playlist.length > 0){
            let plname = editInfo.plname; // data.get("playlistName")
            if(plname == null || plname === ""){plname = "BTS Playlist Name"}
            let pldescr =  editInfo.pldescription; //data.get("playlistDescription")
            if(pldescr == null ||pldescr === ""){pldescr = "Make your own playlist.laramon.ch"}
            let pldata = {tracks: playlist, name:plname, description:pldescr}
            songservice.savePlaylist(pldata, auth.getAccessToken(), spotifyuser_id, edit, editInfo.spotifyplaylist_id).then(
                resp => {
                    if(resp.status === 200){
                        resp.json().then(pl_url => {
                            onSaved(pl_url)
                        })
                    } else {
                        mp.mainToast.current.show({
                            severity:'error',
                            summary: 'Playlist Creation Failed',
                            detail: 'Please, try again!',
                            life: 6000})
                    }
                });
        }
    }

    async function savePlaylistToAM() {
        if(playlist.length > 0) {
            let plname = editInfo.plname; // data.get("playlistName")
            if (plname == null || plname === "") {
                plname = "BTS Playlist Name"
            }
            let pldescr = editInfo.pldescription; //data.get("playlistDescription")
            if (pldescr == null || pldescr === "") {
                pldescr = "Make your own playlist.laramon.ch"
            }
            let pldata = {tracks: playlist, name: plname, description: pldescr}

            //let track_ids = ['1772351326', '1599172208', '1654548658']
            let track_ids = playlist.map(track => track.applemusic_id).filter(track => {return(track !== 'undefined')})
            if(track_ids.length < playlist.length){
                mp.mainToast.current.show({severity:'warning', summary: 'Not all songs were found for Apple Music. ' + (playlist.length - track_ids.length) + ' songs were removed', sticky: true, detail: 'I am working on adding all songs of Apple Music (November 2025)! If I forgot some songs, please let me know.',})
            }
            const music = window.MusicKit.getInstance();
            music.authorize().then(res =>{
                amservice.createPlaylist(window.MusicKit.getInstance(), track_ids, plname, pldescr).then(
                    res => {
                        if(res.response.status === 201){
                            // probably only works because set to public
                            // maybe replace ch with some info from MusicKit
                            let plurl = "https://music.apple.com/playlist/"+res.data.data[0]["attributes"]["playParams"]["globalId"];//res.data.data[0].id
                            onSaved(plurl);
                            amservice.logGeneratedAMPlaylist(plurl, track_ids.length ,auth.getAccessToken());
                        } else {
                            mp.mainToast.current.show({
                                severity:'error',
                                summary: 'Not authorized to edit the playlist',
                                detail: 'Please check if you are still connected to Apple Music. ' +
                                    'Error is ' + res.response.status + " " + res.response.statusText + '. ' +
                                    'If you still cannot save after a few retries, please try disconnecting AM ' +
                                    'and reconnecting again. Sorry for the inconvenience!',
                                sticky: true})
                        }

                        //res.data.data[0].id;
                        // todo save under generated playlists am (separate table) ... or at least log something!
                    }
                )
            })
        }
    }

    function connectAM() {
        const music = window.MusicKit.getInstance();

        music.authorize().then(res =>{
            if(res != undefined){
                setShowAMConnectDialog(false);
                auth.setIsAMauthorized(true); // probably should move this to App.js
            }
        });
    }

    const savePlaylistButton = () => {
        if(spotifyUsers.length > 0){
            let items = [];
            for(let i=0; i<spotifyUsers.length; i++) {
                let spotifyUser = spotifyUsers[i];
                if(spotifyUser.is_connected){
                    items.push(
                        {
                            label: 'Save To' + spotifyUser.spotify_name,
                            icon: 'pi pi-user',
                            command: () => {
                                savePlaylistToSpotify(spotifyUser.id);
                            },
                        }
                    )
                }
            }

            if(items.length > 0){
                return <SplitButton label="Save Playlist (public)" onClick={ () => savePlaylistToSpotify(null)} model={items} disabled={buttonsDisabled}/>
            } else {
                return <Button label="Save Playlist to Spotify" onClick={() => savePlaylistToSpotify(null)} aria-label="Submit" disabled={buttonsDisabled}/>
            }
        } else {
            return <Button label="Save Playlist to Spotify" onClick={() => savePlaylistToSpotify(null)} aria-label="Submit" disabled={buttonsDisabled}/>
        }
    }

    const editPlaylist = () => {
        if(editInfo.editable){
            savePlaylistToSpotify(editInfo.spotifyuser_id, editInfo.editable) //
        } else {
            mp.mainToast.current.show({
                severity:'error',
                summary: 'Not authorized to edit the playlist',
                detail: 'Please check if you are still logged in!',
                life: 6000})
        }
        setShowEditDialog(false);
    }

    const editPlaylistButton = () => {
        if(editInfo.editable){
            return <Button label="Edit Playlist (=replace existing playlist)" onClick={()=> setShowEditDialog(true)} disabled={buttonsDisabled}/>
        } else {
            return ""
        }

    }

    const prepareAMconnection = () => {
        // here I could add MusicKit loading etc. if I decide to stop loading it at startup
        setShowAMConnectDialog(true)
    }

    const savePlaylistToAMButton = () => {
        if(auth.musicKitLoaded){
            // const music = window.MusicKit.getInstance();
            //if(music !== undefined && music.isAuthorized){
            if(auth.isAMauthorized){
                return <Button icon="pi pi-apple" onClick={() => savePlaylistToAM(null)} disabled={buttonsDisabled}>Save Playlist to AM</Button>
            } else {
                return <Button icon="pi pi-apple" onClick={() => prepareAMconnection()} >Connect Apple Music</Button>
            }
        } else {
            return <Button icon="pi pi-apple" disabled={true}>Connect AM not ready</Button>
        }
    }
   // {savePlaylistButton()} {editPlaylistButton()}
    return(
        <div className="card flex flex-wrap gap-1 mt-2">
            <InputText value={editInfo.plname} onChange={(e) => {
                let _editInfo = {...editInfo}; _editInfo.plname = e.target.value
                setEditInfo(_editInfo)}}  placeholder="BTS Playlist Name"/>
            <InputText value={editInfo.pldescription}
                       onChange={(e) => {
                let _editInfo = {...editInfo}; _editInfo.pldescription = e.target.value
                setEditInfo(_editInfo)}}  placeholder="Make your own playlist.laramon.ch"/>

            {savePlaylistToAMButton()}
            <Dialog header={"Connecting to Apple Music"} style={{ width: '450px' }} visible={showAMconnectDialog} onHide={() => setShowAMConnectDialog(false)}>
                <p>No Apple Music? Please check <a href="http://playlist.laramon.ch">playlist.laramon.ch</a> to generate spotify playlist.</p>

                <p>In order to save playlists to Apple Music, you need to login with your Apple Id (connected to AM). The connection is saved in the browser.</p>
                <p>To disconnect again, there are 2 options:
                    <ul>
                        <li>Click the apple logo in the top right corner (appears after successful connection).</li>
                        <li>Edit access in your apple music account: Apple Music -> Account -> Apps with Access (This app is called: BTS Playlist Generator)</li>
                    </ul>
                </p>
                <Button onClick={connectAM}>Connect to Apple Music</Button>
            </Dialog>

            <Dialog header={"Edit Spotify Playlist"} style={{ width: '450px' }} visible={showEditDialog} onHide={() => setShowEditDialog(false)}>
                <p>Are you sure you want to overwrite the playlist you loaded?</p>
                <Button onClick={editPlaylist} label={"Yes"} className="mt-2"/>
            </Dialog>
        </div>
    )
}